import gql from "graphql-tag";
gql`
	query appLookups(
		$where: AppLookupInfoFilterInput
		$order: [AppLookupInfoSortInput!]
		$skip: Int
		$take: Int
	) {
		appLookups(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				entityName
				title
			}
		}
	}
`;
gql`
	query appLookup($entityName: String!) {
		appLookups(where: { entityName: { eq_ci: $entityName } }) {
			items {
				id
				entityName
				title
			}
		}
	}
`;
const GET_LOOKUP_DATA = gql`
	query lookupData(
		$entityName: String!
		$where: BaseLookupFilterInput
		$order: [BaseLookupSortInput!]
		$skip: Int
		$take: Int
	) {
		lookupData(
			entityName: $entityName
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
			}
		}
	}
`;
const GET_CREATIO_LOOKUP_DATA = gql`
	query creatioLookupData(
		$entityName: String!
		$where: CreatioBaseLookupFilterInput
		$order: [CreatioBaseLookupSortInput!]
		$skip: Int
		$take: Int
	) {
		baseCreatio {
			creatioLookupData(
				entityName: $entityName
				where: $where
				order: $order
				skip: $skip
				take: $take
			) {
				pageInfo {
					hasNextPage
				}
				items {
					id
					name
				}
			}
		}
	}
`;
gql`
	mutation createOrUpdatePortalLookup($input: PortalLookupInput!) {
		portalLookup(input: $input) {
			id
		}
	}
`;
export {
  GET_CREATIO_LOOKUP_DATA,
  GET_LOOKUP_DATA
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
